import axios from "axios";
import { API_GET_PRODUCT_CATEGORIES_BAR_DATA, API_INSERT_PRODUCT_CATEGORY_BAR_DATA, API_TOGGLE_PRODUCT_CATEGORY_BAR_DATA, API_UPDATE_PRODUCT_CATEGORY_BAR_DATA } from ".";

export const getProductCategoriesBarList = async (func, config) => {
    return axios.get(API_GET_PRODUCT_CATEGORIES_BAR_DATA, config).then(res => func(res.data.data));
}

export const insertProductCategoryBarData = async (data, config) => {
    return axios.post(API_INSERT_PRODUCT_CATEGORY_BAR_DATA, data, config).then((res) => res.data);
};

export const updateProductCategoryBarData = async (data, config) => {
    return axios.post(API_UPDATE_PRODUCT_CATEGORY_BAR_DATA, data, config).then((res) => res.data);
};

export const toggleProductCategoryBarData = async (data, config, cb) => {
    return axios.put(API_TOGGLE_PRODUCT_CATEGORY_BAR_DATA, data, config).then((res) => {
        if (res.data.status === "success") {
            cb();
        };
    });
};